import React from "react";
import moment from "moment";
import RatingComponent from "react-rating";

import Table from 'react-simpliest-table';

const RatingResult = ({ value, surveys, handleState })=>{
    const [data, setData] = React.useState({ avg: 0});
    
    React.useEffect(()=>{
        const counter = {
            c1: 0,
            c2: 0,
            c3: 0,
            c4: 0,
            c5: 0,
            avg: 0,
            count: 0
        };

        surveys.forEach((survey)=>{
            if (counter.avg === 0){
                counter.avg = survey[value];
            }
            
            if (survey[value]){
                counter[`c${survey[value]}`]++;
                counter['count']++;
                counter.avg = (counter.avg + survey[value])/2;
            }
        });
        setData(counter);
    }, [value, surveys]);

    const ratingData = [ data.c5, data.c4, data.c3, data.c2, data.c1 ];
    return (
        <React.Fragment>
            <h4><strong>{data.count}</strong> Respuestas en total, con un promedio de <strong>{data.avg.toFixed(2)}</strong></h4>

            <div className="text-center">
                {ratingData.map((rating, index)=>{
                    if (rating === undefined){
                        return null;
                    }

                    return (
                        <div key={index}>
                            <RatingComponent
                                fullSymbol="far fa-star mr-1 fa-3x"
                                emptySymbol="fas fa-star mr-1 fa-3x color-gold"
                                readonly={true}
                                initialRating={(index)}
                            />
                            <span className="d-inline-block text-right" style={{width: "90px", fontSize: "22px", fontWeight: 300}}>{((rating * 100) / data.count).toFixed(0)}% ({rating})</span>
                        </div>
                    )
                })}
            </div>
            <h4>Puntaje individual</h4>
            <Table
                list={surveys}
                filterFunction={record => `${record.name}`}
                defaultMaxRecordPerPage={25}
                defaultSorter={{ parameter: "startDate", order: "DESC" }}
                labels={{
                    "all": "Mostrar todos",
                    "records_per_page": "Registros por página",
                    "showing": "Está mostrando",
                    "to": "a",
                    "of": "de",
                    "rows": "filas",
                    "no_data": "Tu listado está vacío",
                    "no_data_filtered": "Sin coincidencias filtradas",
                    "filter": "Pon tu filtro aquí"
                }}
                iterateFunction={(survey) => {
                    return (
                        <tr key={survey.id}>
                            <td>
                                <RatingComponent
                                    emptySymbol="far fa-star mr-1"
                                    fullSymbol="fas fa-star mr-1 color-gold"
                                    readonly={true}
                                    initialRating={(survey[value] || 0)}
                                />
                            </td>
                            <td> {moment.unix(survey.startDate).format("YYYY-MM-DD HH:mm:ss")} </td>
                            <td>{survey.name}</td>
                            <td className="text-right">{(survey.avg * 100 / 5).toFixed(0)}%</td>
                            <td>
                                <span onClick={() => {
                                    handleState({ individual: true, individualData: survey })
                                }} className="btn btn-primary btn-sm">Ver éste feedback</span>
                            </td>
                        </tr>
                    )
                }}
                fields={[{
                    text: "Puntaje",
                    parameter: value
                }, {
                    text: "Fecha",
                    parameter: "startDate"
                }, {
                    text: "Nombre",
                    parameter: "name"
                }, {
                    text: "Indice de satisfacción",
                    parameter: "avg"
                }, {
                    text: "Feedback",
                    sortable: false
                }]} />
        </React.Fragment>
    )
}

export default RatingResult;